import { useContext } from "react";

import { StepperContext } from "../../Contexts/Stepper";
import { LanguageContext } from "../../Contexts/Language";
import { LANGUAGES } from "../../utils/constants";
import messages from "../../utils/messages";

export const Step1 = () => {
  const { step, setStep } = useContext(StepperContext);
  const { lang } = useContext(LanguageContext);

  const { deleteConfirmMsg, iAgree } = messages[lang];

  return (
    <div>
      <p>{deleteConfirmMsg}</p>
      <button
        type="button"
        onClick={() => {
          setStep(step + 1);
        }}>
        {iAgree}
      </button>
    </div>
  );
};
